import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_/action-groups")({
	component: ActionGroupsLayout,
});

function ActionGroupsLayout() {
	return <Outlet />;
}
